import { useRef, useState } from 'react';
import Button from '@/components/inputs/button';
import {
  VARIANT as BUTTON_VARIANT,
  SIZE as BUTTON_SIZE,
} from '@/components/inputs/button/button.types';
import Dialog from '@/components/feedback/dialog';
import Icon from '@/components/data-display/icon/icon';
import { VARIANT as ICON_VARIANT } from '@/components/data-display/icon/icon.types';
import type { FavouriteButtonProperties } from './favourite-button.types';
import styles from './favourite-button.module.scss';

const FavouriteButton = ({
  isFavourited,
  handleFavourite,
  addLabel,
  removeLabel,
  addedLabel,
  removedLabel,
}: FavouriteButtonProperties) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [dialogText, setDialogText] = useState<string>('');
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const handleFavouriteClick = async (): Promise<void> => {
    setShowDialog(false);
    clearTimeout(timer?.current);

    const result = await handleFavourite(!isFavourited);
    setShowDialog(true);
    if (Array.isArray(result?.data)) setDialogText(addedLabel);
    else if (result?.data?.favourite_id) setDialogText(removedLabel);

    await new Promise(resolve => {
      timer.current = setTimeout(() => {
        resolve(setShowDialog(false));
      }, 1500);
    });
  };

  const label = isFavourited ? removeLabel : addLabel;

  return (
    <div className={styles['favourite-button']}>
      <Dialog
        className={styles['favourite-button__dialog']}
        isOpen={showDialog}
      >
        {dialogText}
      </Dialog>
      <div className={styles['favourite-button__cta-wrapper']}>
        <Button
          onClick={handleFavouriteClick}
          variant={BUTTON_VARIANT.Outlined}
          size={BUTTON_SIZE.Large}
          className={styles['favourite-button__cta-wrapper-button']}
          title={label}
          aria-label={label}
        >
          <Icon
            variant={
              isFavourited ? ICON_VARIANT.HeartFilled : ICON_VARIANT.Heart
            }
          />
        </Button>
      </div>
    </div>
  );
};

export default FavouriteButton;
